import { useState } from 'react';
import { ErrorContent } from './ErrorContent/ErrorContent';
import { FormContent } from './FormContent/FormContent';
import { Modal } from 'components/Modal/Modal';
import { appActions } from 'store/app/slice';
import { useDispatch } from 'store/utils';

export const EditPatientModal = () => {
  const dispatch = useDispatch();

  const [displayError, setDisplayError] = useState(false);

  const handleClose = () => {
    dispatch(
      appActions.setIsModalOpened({
        name: 'editPatientInfo',
        isOpened: false,
      }),
    );
  };

  return (
    <Modal title="Edit patient info" onClose={handleClose}>
      {displayError ? (
        <ErrorContent onConfirm={handleClose} />
      ) : (
        <FormContent onClose={handleClose} setDisplayError={setDisplayError} />
      )}
    </Modal>
  );
};
